import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { EmployeeQueryKey } from './queryKey';
export const useGetEmployee = (id) => {
    const intl = useIntl();
    return useQuery([EmployeeQueryKey.Employee, id], () => api.base.get(`/api/employee/${id}`).then(res => res.data), {
        enabled: !!id,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
export default useGetEmployee;
